<template>
    <CBadge
        v-if="visible"
        color="info"
        class="ml-2"
    >
        Стол заказов
    </CBadge>
</template>

<script>
import Vue from 'vue';

export default {
    name: 'RestaurantTableOrderBadge',

    props: {
        show: {
            default: undefined
        }
    },

    data() {
        return {
            fetched: false
        };
    },

    computed: {
        isRestaurantPage() {
            const path = this.$route && this.$route.path ? this.$route.path : '';
            return path.indexOf('/restaurants/') === 0 && !!this.$route.params.id;
        },

        visible() {
            if (!this.isRestaurantPage) return false;
            if (typeof this.show === 'boolean') return this.show;
            return this.fetched;
        }
    },

    watch: {
        '$route.params.id': {
            immediate: true,
            handler() {
                this.load();
            }
        }
    },

    methods: {
        load() {
            if (typeof this.show === 'boolean' || !this.isRestaurantPage) return;
            const id = this.$route.params.id;
            Vue.axios.get('/restaurants/' + id)
                .then(({ data }) => {
                    this.fetched = !!data.show_in_table_orders;
                })
                .catch(() => {
                    this.fetched = false;
                });
        }
    }
};
</script>
